module.exports = __webpack_public_path__ + "img/0.1b9e6c67.png";